































































































import Vue from 'vue';
import { Type, TypeMap, Expression, OperationExpression, ObjectType, ExpressionMap, NoExpression, ConstantExpression } from 'expangine-runtime';
import { LiveRuntime } from 'expangine-runtime-live';
import { OperationVisuals } from '../runtime/ops/OperationVisuals';
import { testOperationDialog, PREF_FULLSCREEN_TEST_OPERATION } from './TestOperation';
import { Preferences } from './Preference';


export default Vue.extend({
  data: () => testOperationDialog,
  computed: {
    isFullscreen(): boolean {
      return this.$vuetify.breakpoint.mdAndDown || this.fullscreen;
    },
    isFullscreenToggleVisible(): boolean {
      return !this.$vuetify.breakpoint.mdAndDown;
    },
    visuals(): OperationVisuals {
      return this.registry.getOperationVisuals(this.name);
    },
    paramTypes(): TypeMap {
      return this.registry.defs.getOperationExpectedTypes(this.name, this.params, {}, this.context);
    },
    paramsFiltered(): ExpressionMap {
      const filtered: ExpressionMap = {};
      for (const prop in this.params) {
        if (this.params[prop] !== NoExpression.instance) {
          filtered[prop] = this.params[prop];
        }
      }
      return filtered;
    },
  },
  watch: {
    params: {
      deep: true,
      handler() {
        this.updateResult();
      },
    },
  },
  methods: {
    toggleFullscreen() {
      this.fullscreen = !this.fullscreen;

      Preferences.set(PREF_FULLSCREEN_TEST_OPERATION, this.fullscreen);
    },
    setConstant(name: string, value: any) {
      const paramExpr = this.params[name];
      if (value === undefined || value === null) {
        this.$set(this.params, name, NoExpression.instance);
      } else if (paramExpr instanceof NoExpression) {
        this.$set(this.params, name, new ConstantExpression(value));
      } else if (paramExpr instanceof ConstantExpression) {
        paramExpr.value = value;
      }
      this.updateResult();
    },
    showDefault(name: string) {
      if (!this.op || this.op.optional.indexOf(name) === -1) {
        return false;
      }
      if (!this.visuals.defaults[name]) {
        return false;
      }
      const param = this.params[name];
      if (!param) {
        return false;
      }
      if (param instanceof ConstantExpression) {
        return param.value === undefined;
      }
      if (param instanceof NoExpression) {
        return true;
      }

      return false;
    },
    setParam(name: string, expr?: Expression) {
      this.$set(this.params, name, expr || NoExpression.instance);
      this.updateResult();
    },
    paramContext(name: string): Type {
      const defs = this.registry.defs;
      const { op, types } = this;
      
      if (op && types && op.hasScope.indexOf(name) !== -1) 
      {
        return this.scopedContext();
      }

      return this.context;
    },
    paramContextDetails(name: string): Record<string, string> {
      const defs = this.registry.defs;
      const { op, types, visuals } = this;
      let details: Record<string, string> = {};

      if (op && types && op.hasScope.indexOf(name) !== -1) 
      {
        details = { ...details };
        
        for (const scopeParam of op.scope)
        {
          details[scopeParam] = visuals.scopeComments[scopeParam];
        }
      }

      return details;
    },
    scopedContext(): Type {
      const defs = this.registry.defs;
      const { op, types } = this;
      
      if (!op || !types)
      {
        return this.context;
      }

      const { context, scope } = defs.getContextWithScope(this.context);

      for (const scopeParam of op.scope) 
      {
        const scopeType = defs.getOperationInputType(types.scope[scopeParam], this.paramTypes);

        if (scopeType) 
        {
          scope[scopeParam] = scopeType.getSimplifiedType();
        }
      }

      return context;
    },
    updateResult(forceUpdate: boolean = false) {
      if (!this.resultAutomatic && !forceUpdate) {
        return;
      }

      try {
        this.invalid = false;

        const op = new OperationExpression(this.name, this.paramsFiltered);
        const cmd = LiveRuntime.getCommand(op);

        this.result = cmd({});
      } catch (e) {
        this.invalid = true;
      }
    },
  },
});
